import { resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-4c14c4b1"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "score mohu",
  style: {
    "margin-top": "20px"
  }
};
const _hoisted_2 = {
  key: 0,
  class: "mohu-filter"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "解锁", -1));
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "tips"
}, " 注：招生人数基于录取名单统计，并非计划招生人数（PS:实际录取人数一般大于计划招生人数） ", -1));
import { Bell } from "@element-plus/icons-vue";
import { ref, onMounted } from "vue";
import { scoreAnalysis } from "@/api/api";
import { decrypt } from "@/utils/parseDate";
import { ElMessage } from "element-plus";
import { useStore } from "vuex";
export default {
  __name: 'RecruitStudent',
  props: {
    majorId: String
  },
  emits: ["onChange"],
  setup(__props, {
    expose: __expose,
    emit
  }) {
    const props = __props;
    const store = useStore();

    // 点击解锁
    function onUnlock() {
      emit("onChange", {
        isUnlock: true
      });
    }
    const tableData = ref([]);
    const loading = ref(false);
    // 是否显示模糊效果
    const isUnlock = ref(false);
    async function getScoreAnalysis() {
      try {
        loading.value = true;
        const data = {
          majorOutRelationId: props.majorId
        };
        const result = await scoreAnalysis(data);
        const res = JSON.parse(decrypt(result));
        console.log(res);
        if (res.status == 8) {
          store.commit("setTipsDialog", true);
        }
        if (res.status == 9) {
          store.commit("setNumberDialog", true);
        }
        if (res.status == 666) {
          ElMessage({
            message: res.msg,
            type: "warning",
            showClose: true
          });
          isUnlock.value = true;
          emit("onChange", {
            isUnlock: true
          });
          tableData.value = [{
            ssnf: "请解锁查看",
            total: "请解锁查看",
            yzylqrs: "请解锁查看",
            tjrs: "请解锁查看"
          }, {
            ssnf: "请解锁查看",
            total: "请解锁查看",
            yzylqrs: "请解锁查看",
            tjrs: "请解锁查看"
          }, {
            ssnf: "请解锁查看",
            total: "请解锁查看",
            yzylqrs: "请解锁查看",
            tjrs: "请解锁查看"
          }, {
            ssnf: "请解锁查看",
            total: "请解锁查看",
            yzylqrs: "请解锁查看",
            tjrs: "请解锁查看"
          }, {
            ssnf: "请解锁查看",
            total: "请解锁查看",
            yzylqrs: "请解锁查看",
            tjrs: "请解锁查看"
          }, {
            ssnf: "请解锁查看",
            total: "请解锁查看",
            yzylqrs: "请解锁查看",
            tjrs: "请解锁查看"
          }, {
            ssnf: "请解锁查看",
            total: "请解锁查看",
            yzylqrs: "请解锁查看",
            tjrs: "请解锁查看"
          }, {
            ssnf: "请解锁查看",
            total: "请解锁查看",
            yzylqrs: "请解锁查看",
            tjrs: "请解锁查看"
          }, {
            ssnf: "请解锁查看",
            total: "请解锁查看",
            yzylqrs: "请解锁查看",
            tjrs: "请解锁查看"
          }];
        }
        if (res.status === 0) {
          isUnlock.value = false;
          res.result.forEach(ele => ele.total = ele.yzylqrs + ele.tjrs);
          tableData.value = res.result.reverse();
        }
        loading.value = false;
      } catch (error) {
        // throw new Error(error)
      }
    }
    // 将 myMethod 暴露给父组件
    __expose({
      childMethod
    });
    function childMethod() {
      getScoreAnalysis();
    }
    onMounted(() => {
      getScoreAnalysis();
    });
    return (_ctx, _cache) => {
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_table = _resolveComponent("el-table");
      const _component_Key = _resolveComponent("Key");
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_button = _resolveComponent("el-button");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", _hoisted_1, [_withDirectives((_openBlock(), _createBlock(_component_el_table, {
        "element-loading-text": "数据加载中",
        "empty-text": "暂无数据，请重新选择条件查询",
        data: tableData.value,
        style: {
          "width": "100%",
          "min-height": "280px"
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_el_table_column, {
          prop: "ssnf",
          label: "年份",
          width: "180"
        }), _createVNode(_component_el_table_column, {
          prop: "total",
          label: "总招生人数"
        }), _createVNode(_component_el_table_column, {
          prop: "yzylqrs",
          label: "一志愿人数"
        }), _createVNode(_component_el_table_column, {
          prop: "tjrs",
          label: "调剂人数"
        })]),
        _: 1
      }, 8, ["data"])), [[_directive_loading, loading.value]]), isUnlock.value ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(_component_el_button, {
        type: "success",
        onClick: onUnlock
      }, {
        default: _withCtx(() => [_createVNode(_component_el_icon, {
          class: "el-icon--right"
        }, {
          default: _withCtx(() => [_createVNode(_component_Key)]),
          _: 1
        }), _createTextVNode(), _hoisted_3]),
        _: 1
      })])) : _createCommentVNode("", true)]), _hoisted_4]);
    };
  }
};